// MSAL configuration. Single-tenant authority (only the NursePartners tenant),
// plus an explicit @nursepartners.net check in App.js as a second gate. The
// backend independently enforces the same domain on every request.

const TENANT_ID = process.env.REACT_APP_ENTRA_TENANT_ID || "";
const CLIENT_ID = process.env.REACT_APP_ENTRA_CLIENT_ID || "";
export const ALLOWED_DOMAIN = "nursepartners.net";
// Basic OIDC scopes only — no custom API scope, so no admin consent is ever
// required. The backend validates the resulting sign-in (ID) token.
export const ID_SCOPES = ["openid", "profile", "email"];

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID || "organizations"}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false },
};

// Login scopes: standard OIDC only.
export const loginRequest = { scopes: ID_SCOPES };

// True when Entra is configured; when it isn't, the app runs in "open" mode
// against a backend started with AUTH_DISABLED=true (local development only).
export const authConfigured = Boolean(CLIENT_ID && TENANT_ID);
